import * as React from "react";
import { SVGProps } from "react";
const List = ({ ...props }: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "#211E1E"}
      fillRule="evenodd"
      d="M3.75 23.438a.937.937 0 0 1 .938-.938h20.625a.938.938 0 0 1 0 1.875H4.688a.938.938 0 0 1-.938-.938Zm0-5.625a.937.937 0 0 1 .938-.938h20.625a.938.938 0 0 1 0 1.875H4.688a.938.938 0 0 1-.938-.938Zm0-5.625a.937.937 0 0 1 .938-.938h20.625a.938.938 0 0 1 0 1.875H4.688a.938.938 0 0 1-.938-.938Zm0-5.626a.937.937 0 0 1 .938-.937h20.625a.937.937 0 0 1 0 1.875H4.688a.937.937 0 0 1-.938-.938Z"
      clipRule="evenodd"
    />
  </svg>
);
export default List;
